import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import back1 from './images/back1.svg'
import back2 from './images/back2.svg'
import back3 from './images/back3.svg'
import back4 from './images/back4.svg'
import back5 from './images/back5.svg'
import back6 from './images/back6.svg'
import back7 from './images/back7.svg'

const RootContainer = styled.div`
	position: relative;
	display: inline-block;
	
	${props => props.blobType === 1 && `
		margin: 3rem 0;
	`}
	
	${props => props.blobType === 5 && `
		margin: 3.7rem 0 4rem;
	`}
	
	${props => props.blobType === 6 && `
		margin: 3.7rem 0 4rem;
	`}
	
	${props => props.blobType === 7 && `
		margin: 3.7rem 0 4rem;
	`}
`

const BlobImage = styled.div`
	position: absolute;
	background-size: 100% 100%;
	
	${props => props.blobType === 1 && `
		top: -3rem;
		left: -6rem;
		right: -3rem;
		bottom: -1rem;
		background-image: url('${back1}');
	`}
	
	${props => props.blobType === 2 && `
		top: -1rem;
		left: -4rem;
		right: -3rem;
		bottom: 0rem;
		background-image: url('${back2}');
	`}
	${props => props.blobType === 3 && `
		top: 0rem;
		left: -4rem;
		right: -6rem;
		bottom: 0rem;
		background-image: url('${back3}');
	`}
	
	${props => props.blobType === 4 && `
		top: -6rem;
		left: -6rem;
		right: -4rem;
		bottom: -6rem;
		background-image: url('${back4}');
	`}
	
	${props => props.blobType === 5 && `
		top: -3.7rem;
		left: -4rem;
		right: -4rem;
		bottom: -4rem;
		background-image: url('${back5}');
	`}
	
	${props => props.blobType === 6 && `
		top: -3.7rem;
		left: -3rem;
		right: -2rem;
		bottom: -4rem;
		background-image: url('${back6}');
	`}
	
	${props => props.blobType === 7 && `
		top: -3.7rem;
		left: -3rem;
		right: -2rem;
		bottom: -4rem;
		background-image: url('${back7}');
	`}
`


const BlobContent = styled.div`
	color: white;
	position: relative;
	
	${props => props.blobType === 1 && `
		padding: 4rem 0 4rem;
	`}
	
	${props => props.blobType === 2 && `
		padding: 4rem 0 3rem;
	`}
	${props => props.blobType === 3 && `
		padding: 3rem 0 2rem;
	`}
	
	${props => props.blobType === 4 && `
		padding: 0rem 0 0rem;
	`}
	
	${props => props.blobType === 5 && `
		padding: 0rem 0 0rem;
		color: black;
	`}
	
	${props => props.blobType === 6 && `
		padding: 0rem 0 0rem;
		color: black;
	`}
	
	${props => props.blobType === 7 && `
		padding: 0rem 0 0rem;
		color: black;
	`}
	
	
	${props => props.minimalWidth && `
		display: inline-flex;
		align-items: flex-start;
		flex-direction: column;
	`}
`

const Blob = ({className, minimalWidth, blobType, children}) => {
	return <RootContainer blobType={blobType} className={className}>
		<BlobImage blobType={blobType}/>
		<BlobContent blobType={blobType} minimalWidth={minimalWidth}>{children}</BlobContent>
	</RootContainer>
}

Blob.propTypes = {
	className: PropTypes.string,
	blobType: PropTypes.oneOf([1, 2, 3, 4]).isRequired,
	children: PropTypes.node.isRequired,
	minimalWidth: PropTypes.bool,
}

Blob.defaultProps = {
	className: '',
	minimalWidth: false,
}

export default Blob
